'use strict';

angular.module('randomization')
    .component('randomizationLog', {
        templateUrl: 'modules/randomization/components/log/content.html',
        controller: 'RandomizationLogController',
        bindings: {
            sitesAvailable: '<',
        },
    });
